import React from 'react';

const Retweet: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 51 34" {...props}>
    <path
      fill="currentColor"
      d="M49.764 24.614l-8.287 8.125a.97.97 0 01-1.352 0l-8.288-8.125a.925.925 0 010-1.326l1.345-1.319a.97.97 0 011.36.008l4.346 4.356V8.875H22.634a.972.972 0 01-.676-.275l-1.913-1.875c-.602-.59-.176-1.6.676-1.6h20.08c1.056 0 1.912.84 1.912 1.875v19.333l4.347-4.356a.97.97 0 011.36-.008l1.344 1.319a.925.925 0 010 1.326zm-20.72.786a.966.966 0 00-.676-.275H12.113V7.667l4.347 4.356a.97.97 0 001.36.008l1.345-1.319a.925.925 0 000-1.326l-8.288-8.125a.97.97 0 00-1.352 0L1.237 9.386a.925.925 0 000 1.326l1.345 1.319a.97.97 0 001.36-.008l4.346-4.356V27c0 1.035.856 1.875 1.913 1.875h20.08c.851 0 1.278-1.01.675-1.6L29.044 25.4z"
    ></path>
  </svg>
);

export default Retweet;
